/**
 * promoimmoEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { VisitEntity } from "../VisitEntity";
import { promoimmoEntity } from "../promoimmoEntity";
declare global {
    interface EntityTypeMap {
        promoimmo: promoimmoEntity;
    }
}
export abstract class promoimmoGeneratedEntity extends BaseEntity {
    public abstract promoimmoId: string;
    public abstract promoimmo_moa_represente: string | null;
    public abstract promoimmo_moa_qualite: string | null;
    public abstract promoimmo_represente: string | null;
    public abstract promoimmo_societe: string | null;
    public abstract promoimmo_qualite: string | null;
    public abstract promoimmo_nbr_jours_lever: number | null;
    public abstract promoimmo_declare: string | null;
    public abstract promoimmo_motif_non_reception: string | null;
    public abstract promoimmo_num_batiment: string | null;
    public abstract promoimmo_num_logement: string | null;
    public abstract promoimmo_num_parking: string | null;
    public abstract promoimmo_num_cave: string | null;
    public abstract promoimmo_description_travaux: string | null;
    public abstract promoimmo_vigiks: number | null;
    public abstract promoimmo_cle_paliere: number | null;
    public abstract promoimmo_carte_paliere: number | null;
    public abstract promoimmo_cle_garage: number | null;
    public abstract promoimmo_cle_caves: number | null;
    public abstract promoimmo_bal: number | null;
    public abstract promoimmo_telecommande_vr: number | null;
    public abstract promoimmo_acces_parking: number | null;
    public abstract promoimmo_emetteur_ssol: number | null;
    public abstract promoimmo_emetteur_portail: number | null;
    public abstract promoimmo_notes_clefs: string | null;
    public abstract promoimmo_donne_quitus: boolean | null;
    public abstract promoimmo_paiment_regle: boolean | null;
    public abstract promoimmo_cheque_recu: boolean | null;
    public abstract promoimmo_cheque_montant: string | null;
    public abstract promoimmo_compteur_eau_froid: string | null;
    public abstract promoimmo_compteur_eau_chaud: string | null;
    public abstract promoimmo_compteur_chauffage: string | null;
    public abstract promoimmo_compteur_gaz: string | null;
    public abstract promoimmo_compteur_electricite: string | null;
    public abstract promoimmo_dpe: string | null;
    public abstract promoimmo_certification: string | null;
    public abstract promoimmo_chaudiere: string | null;
    public abstract promoimmo_thermostat: string | null;
    public abstract promoimmo_radiateur: string | null;
    public abstract promoimmo_videophone: string | null;
    public abstract promoimmo_kitchenette: string | null;
    public abstract promoimmo_comptage: string | null;
    public abstract promoimmo_emetteur_garage: string | null;
    public abstract promoimmo_telecommande_bso: string | null;
    public abstract promoimmo_coffret_comm: string | null;
    public abstract promoimmo_code_acces: string | null;
    public abstract promoimmo_legal_country: string | null;
    public abstract visit: VisitEntity;
}
